export default "__VITE_ASSET__BduEJVV9__"